import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Users from '../../../components/users/Users';
import NothingFound from '../../../components/NothingFound';
import InviteUser from '../../../components/invitations/InviteUser';
import AddMemberSearch from '../../../components/addMember/AddMemberSearch';

import * as organizationMembersSelectors from '../../../selectors/organizationMembersSelectors';
import * as userSearchSelectors from '../../../selectors/userSearchSelectors';
import * as organizationConstants from '../../../constants/organizations';
import * as organizationInvitationSelector from '../../../selectors/organizationInvitationsSelector';

import { isValidEmail } from '../../../helpers/Util';
import { getCurrentOrganizationId } from '../../../selectors/organizationSelectors';

const ACTIONS = ['Add as member', 'Add as admin'];

class AddOrganizationMembersContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isValidEmail: false };
    }

    onSearchChange = value => {
        if (!value || !value.trim()) {
            this.setState({
                isValidEmail: false,
                email: undefined,
            });
            return;
        }
        const { searchUsers } = this.props;
        searchUsers(value);
        this.setState({
            isValidEmail: isValidEmail(value),
            email: value,
        });
    };

    onAddMembers = (usersIds, action) => {
        const { addUsers } = this.props;
        const usersToBeAdded = usersIds.map(userId => ({
            memberId: userId,
            isAdmin: ACTIONS.indexOf(action) === 1,
        }));
        addUsers(usersToBeAdded);
    };

    render() {
        const {
            hideAddMembers,
            inviteUser,
            organizationMembers,
            invitedUsers,
            resendInvite,
        } = this.props;
        const foundUsers = this.props.users || [];
        const { isValidEmail, email } = this.state;

        const isAlreadyMember =
            undefined !==
            organizationMembers.find(member =>
                foundUsers.find(user => member.userId === user.id),
            );

        const existingInvitation = invitedUsers.find(
            invitation => invitation.invitedEmail === email,
        );
        const filteredUsers = foundUsers.filter(
            user =>
                organizationMembers.findIndex(
                    member => member.userId === user.id,
                ) === -1,
        );

        const renderNothingFound = !filteredUsers.length && !isValidEmail && !!email;
        const renderInvitation = !filteredUsers.length && isValidEmail;

        return (
            <React.Fragment>
                <AddMemberSearch
                    onBack={hideAddMembers}
                    onChange={this.onSearchChange}
                    searchPlaceholder="Type an email..."
                />
                <Users
                    users={filteredUsers}
                    actions={ACTIONS}
                    onAction={this.onAddMembers}
                    showIndividualActions={false}
                />
                {renderNothingFound && <NothingFound />}
                {renderInvitation && (
                    <InviteUser
                        email={email}
                        inviteUser={inviteUser}
                        resendInvite={resendInvite}
                        existingInvitation={existingInvitation}
                        alreadyMember={isAlreadyMember}
                    />
                )}
            </React.Fragment>
        );
    }
}

AddOrganizationMembersContent.propTypes = {
    members: PropTypes.array.isRequired,
    searchUsers: PropTypes.func.isRequired,
    addUsers: PropTypes.func.isRequired,
    users: PropTypes.array,
    hideAddMembers: PropTypes.func.isRequired,
};

AddOrganizationMembersContent.defaultProps = {
    users: undefined,
};

const mapStateToProps = state => {
    return {
        members: organizationMembersSelectors.getMembers(state),
        users: userSearchSelectors.getUserSearchResult(state),
        organizationMembers: state.usersByOrg[getCurrentOrganizationId(state)],
        invitedUsers: organizationInvitationSelector.getInvitations(state),
    };
};

const mapDispatchToProps = dispatch => ({
    searchUsers: searchTerm =>
        dispatch({
            type: organizationConstants.USER_SEARCH_REQUEST,
            payload: { searchTerm },
        }),
    addUsers: usersToBeAdded =>
        dispatch({
            type: organizationConstants.ADD_ORGANIZATION_MEMBERS_REQUEST,
            payload: { usersToBeAdded },
        }),
    inviteUser: payload =>
        dispatch({
            type: organizationConstants.INVITE_ORGANIZATION_MEMBER_REQUEST,
            payload,
        }),
    resendInvite: invitation =>
        dispatch({
            type:
                organizationConstants.RESEND_ORGANIZATION_MEMBER_INVITATIONS_REQUEST,
            payload: { invitation },
        }),
    hideAddMembers: () =>
        dispatch({
            type: organizationConstants.TOGGLE_ADD_MEMBER,
            payload: { isAddMember: false },
        }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddOrganizationMembersContent);



// WEBPACK FOOTER //
// ./src/containers/organizationMembers/addOrganizationMembers/AddOrganizationMembersContent.js